import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Chain = (props: Icon): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    viewBox="0 0 40 40"
    xmlSpace="preserve"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <path
      fill={props.color || theme.palette.grey600}
      fillRule="evenodd"
      d="M26 10c-1.7 0-3 1.3-3 3 0 .2 0 .5.1.7l-7 4.1c-.5-.5-1.2-.8-2-.8-1.7 0-3 1.3-3 3s1.3 3 3 3c.8 0 1.5-.3 2-.8l7.1 4.2c0 .2-.1.4-.1.6 0 1.6 1.3 2.9 2.9 2.9s2.9-1.3 2.9-2.9-1.3-2.9-2.9-2.9c-.8 0-1.4.3-2 .8l-7.1-4.1c0-.2.1-.5.1-.7 0-.2 0-.5-.1-.7l7-4.1c.5.5 1.2.8 2 .8 1.7 0 3-1.3 3-3S27.7 10 26 10z"
      clipRule="evenodd"
    ></path>
  </svg>
);
